import PropTypes from 'prop-types';
import MapService from "./MapService";
import BaseSelectorReadonlyToInput from "../component/Select/BaseSelectorReadonlyToInput";

class MapSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Mapa',
      label: 'friendlyName',
      url: MapService.ALL_URL
    };
  }
}

MapSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MapSelector;



// WEBPACK FOOTER //
// ./src/map/MapSelector.js